export const SHAPE_HEIGHT_WITH_TEXT = 13; // 16?
export const SHAPE_HEIGHT_WITHOUT_TEXT = 8;
export const LINE_GAP = 3;
export const MIN_SHAPE_WIDTH = 1;
export const SHAPE_HORIZONTAL_PADDING_INNER_TEXT = 0;
export const SHAPE_HORIZONTAL_PADDING_OUTER_TEXT = 10;
export const TRACK_VERTICAL_PADDING = 5;
export const FEATURE_TEXT_FONT_STYLE = "11px RobotoMono"; // `RobotoMono` in the worker
export const CHAR_WIDTH = 6.6; // Fixed char width, defined by the 10px monospace font
export const CHAR_HEIGHT = 11;
export const TEXT_LR_PADDING = 8;
// Space between shape and text. There is already 1 empty pixel at the bottom for "_".
// So, it's visually 2px.
export const OUTER_TEXT_VERTICAL_OFFSET = 1;
export const SYNTENY_SHAPE_HEIGHT = 3;
export const SYNTENY_VERTICAL_OFFSET = 1;

export const SEQ_RESIDUE_NU_COLORS: Record<string, string> = {
  A: "hsl(121, 46%, 72%)",
  T: "hsl(16, 100%, 76%)",
  C: "hsl(225, 66%, 79%)",
  G: "hsl(51, 100%, 78%)",
  N: "#dddddd",
};

// Colors for the synteny bars below features (Secondary Light)
export const SYNTENY_GRAY_COLOR = "hsl(240, 1%, 56%)";
export const SAME_GENOME_FILL = "hsl(240, 1%, 56%)";
export const OTHER_GENOME_FILL = "hsla(240, 1%, 56%, 0.33)";
export const STROKE_COLOR = "hsla(240, 1%, 56%, 0.33)";
